import ADVERTISERS_API from 'api/advertisers/v1'
import { push } from 'connected-react-router'
import { startSubmit, stopSubmit, SubmissionError } from 'redux-form'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { ROUTES } from 'constants/routes'
import { generatePath } from 'react-router'
import { notificationShow } from 'modules/Notifications/actions'
import { CREATE_USER } from 'modules/Advertisers/Create/types'

function* createAdvertiser({
  payload: { id, data, formName },
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  const { i18n } = yield select(({ app }) => app)
  try {
    yield put(startSubmit(formName))

    const { error } = yield call(
      id ? ADVERTISERS_API.update : ADVERTISERS_API.create,
      {
        id,
        data,
      },
    )

    if (error) {
      throw error
    }

    yield put(push(generatePath(ROUTES.ADVERTISERS, { i18n })))

    yield put(
      notificationShow({
        type: 'success',
        message: 'common::notifications.data_success_add',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    fields && reject(new SubmissionError({ advertiser_info: { ...fields } }))

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }

    console.logXHR(error)
  } finally {
    yield put(stopSubmit(formName))
  }
}

export default function* Sagas() {
  yield takeLatest(CREATE_USER, createAdvertiser)
}
